import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './InfoBlock.css';


export default class InfoBlock extends Component {
  static propTypes = {
    amount: PropTypes.num,
    type: PropTypes.string,
    description: PropTypes.string,
    borders: PropTypes.array,
    skipBy: PropTypes.num,
    className: PropTypes.string
  }

  render() {
    var h1style, legendStyle;
    if(this.props.size === true) {
      h1style = {'font-size':'1.33em'}
      h1style.color = this.props.amount && this.props.amount > 0 ? 'green' : 'red';
    }
    if(this.props.color) {
      legendStyle = {'background-color': this.props.color}
    }
    return (
      <div className={`InfoBlock ${this.props.className ? this.props.className : ''}`}>
        {this.props.color ? <div class="legend" style={legendStyle}></div> : null}
        {this.props.amount ? <h1 style={h1style}>{this.props.type === 'money' ? '$' : ''}{this.props.amount.toLocaleString()}{this.props.type === 'percentage' ? '%' : ''}</h1>:<h1>0</h1>}
        <h5>{this.props.description}</h5>
        {this.props.borders ? this.props.borders.map((border, idx) => (<div>{ border ? <div className={`border${idx}`} /> : null}</div>)) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoBlockComponent/InfoBlockWithoutCount.js